import type { AxiosInstance } from 'axios';
import { z } from 'zod';

export interface GetAgentSubjectSearchRequest {
  contextIdentifier: string;
  query: string;
}

const subjectSearchResponseSchema = z.object({
  results: z.array(
    z.object({
      entityId: z.number(),
      objectId: z.number().optional(),
      name: z.string(),
      type: z.string(),
      link: z.string().optional(),
    }),
  ),
});

type SubjectSearchResponse = z.infer<typeof subjectSearchResponseSchema>;

export class ChatContextClient {
  constructor(private authenticatedClient: AxiosInstance) { }

  getContextSubjectSearch = async (
    data: GetAgentSubjectSearchRequest,
  ): Promise<SubjectSearchResponse> => {
    const res = await this.authenticatedClient.get<GetAgentSubjectSearchRequest>(
      `/chat/context/${data.contextIdentifier}/subject-search?query=${encodeURIComponent(
        data.query,
      )}`,
    );
    return subjectSearchResponseSchema.parse(res.data);
  };
}